import { customStorage } from './CommonService';
import { STO_GUEST_SESSION } from '../constants/commonConstants';

let cached = null;

export const getGuestSession = () => {
    if (cached) return cached.expiresAt > Date.now() ? cached : (clearGuestSession(), null);
    try {
        const value = JSON.parse(customStorage.getItem(STO_GUEST_SESSION));
        if (value?.accessToken && value?.playerId && value?.expiresAt > Date.now()) return (cached = value);
    } catch (_) { /* invalid local data is discarded */ }
    clearGuestSession(); return null;
};

export const setGuestSession = value => {
    cached = value;
    customStorage.setItem(STO_GUEST_SESSION, JSON.stringify(value));
};

export const clearGuestSession = () => {
    cached = null;
    customStorage.removeItem(STO_GUEST_SESSION);
};

export const getGuestAccessToken = () => getGuestSession()?.accessToken || null;
